document.addEventListener("DOMContentLoaded", (event) => {
    
       // Inicjalizacja GSAP
    gsap.registerPlugin(ScrollTrigger);
    gsap.config({ nullTargetWarn: false });

    // Animacja klipsów w tle (Parallax i obrót przy scrollu)
    gsap.to(".bg-clip-orange", {
        y: 200,
        rotation: 35,
        ease: "none",
        scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom bottom",
            scrub: 1
        }
    });

    gsap.to(".bg-clip-black", {
        y: -150,
        rotation: -45,
        ease: "none",
        scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom bottom",
            scrub: 1
        }
    });

    // Animacja startowa sekcji Hero
    const heroTl = gsap.timeline();
    
    heroTl.fromTo(".hero-title .line", 
        { y: 100, opacity: 0 },
        { y: 0, opacity: 1, duration: 1, stagger: 0.2, ease: "power4.out", delay: 0.2 }
    );

    heroTl.fromTo(".hero-subtitle, .hero-actions",
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.8, stagger: 0.1, ease: "power2.out" },
        "-=0.6"
    );

    // Wejście Wideo
    heroTl.fromTo(".hero-visual",
        { opacity: 0, scale: 0.95, y: 30 },
        { opacity: 1, scale: 1, y: 0, duration: 1.2, ease: "power3.out" },
        "-=0.8"
    );

    // Parallax efekt dla bohatera
    gsap.to(".video-container", {
        yPercent: 20,
        ease: "none",
        scrollTrigger: {
            trigger: ".hero-visual",
            start: "top bottom",
            end: "bottom top",
            scrub: 1
        }
    });

    // Sekcja Bento Grid 
    gsap.fromTo(".section-heading > *",
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.8, stagger: 0.1, ease: "power2.out",
          scrollTrigger: { trigger: ".features", start: "top 80%" }
        }
    );

    // Sekcja Specyfikacji - animacja
    gsap.fromTo(".specs-visual",
        { opacity: 0, x: -50 },
        { opacity: 1, x: 0, duration: 1, ease: "power3.out",
          scrollTrigger: { trigger: ".specs-layout", start: "top 75%" }
        }
    );

    gsap.fromTo(".specs-info > *",
        { opacity: 0, x: 50 },
        { opacity: 1, x: 0, duration: 1, stagger: 0.1, ease: "power3.out",
          scrollTrigger: { trigger: ".specs-layout", start: "top 75%" }
        }
    );
    
    gsap.fromTo(".floating-quote",
        { opacity: 0, y: 50 },
        { opacity: 1, y: 0, duration: 1, ease: "back.out(1.2)",
          scrollTrigger: { trigger: ".floating-quote", start: "top 90%" }
        }
    );

    // Sekcja Heavy Duty & Product Specs - INDYWIDUALNE triggery rozwiązujące błąd ładowania
    gsap.utils.toArray(".hd-info").forEach((info) => {
        gsap.fromTo(info.children,
            { opacity: 0, x: -40 },
            { opacity: 1, x: 0, duration: 0.8, stagger: 0.1, ease: "power2.out",
              scrollTrigger: { trigger: info.parentElement, start: "top 75%" }
            }
        );
    });

    gsap.utils.toArray(".hd-visual").forEach((visual) => {
        gsap.fromTo(visual,
            { opacity: 0, scale: 0.9, y: 30 },
            { opacity: 1, scale: 1, y: 0, duration: 1, ease: "power3.out",
              scrollTrigger: { trigger: visual.parentElement, start: "top 70%" }
            }
        );
    });

    // Sekcja Dystrybucji i formularza
    gsap.fromTo(".dist-header > *, .premium-form",
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, duration: 0.8, stagger: 0.2, ease: "power2.out",
          scrollTrigger: { trigger: ".distribution", start: "top 80%" }
        }
    );

    // Obsługa Formularza Kontaktowego
    const contactForm = document.getElementById('contactForm');
    if (contactForm) {
        contactForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const btn = e.target.querySelector('button');
            const originalText = btn.textContent;
            
            btn.textContent = "Wysłano!";
            btn.style.backgroundColor = "var(--brand-color)";
            btn.style.color = "#000";
            
            setTimeout(() => {
                btn.textContent = originalText;
                btn.style.backgroundColor = "";
                btn.style.color = "";
                e.target.reset();
            }, 3000);
        });
    }

    // System i18n
    const langSelect = document.querySelector('.lang-select');
    if (langSelect && typeof translations !== 'undefined') {
        
        // Zapisz oryginalne (polskie) teksty wygenerowane przez Liquid, 
        // aby nie nadpisywać ich twardym kodem z translations.js dla języka PL
        document.querySelectorAll('[data-i18n]').forEach(el => {
            if (!el.hasAttribute('data-original-text')) {
                if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
                    el.setAttribute('data-original-text', el.placeholder || '');
                } else {
                    el.setAttribute('data-original-text', el.innerHTML);
                }
            }
        });

        const changeLanguage = (lang) => {
            const dict = translations[lang] || translations['EN'] || translations['en']; 
            
            document.querySelectorAll('[data-i18n]').forEach(el => {
                const key = el.getAttribute('data-i18n');
                
                if (lang === 'PL') {
                    // Przywróć to, co klient wpisał w edytorze Shopify
                    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
                        el.placeholder = el.getAttribute('data-original-text');
                    } else {
                        el.innerHTML = el.getAttribute('data-original-text');
                    }
                } else if (dict && dict[key]) {
                    // Użyj słownika dla innych języków
                    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
                        el.placeholder = dict[key];
                    } else {
                        el.innerHTML = dict[key];
                    }
                }
            });
            localStorage.setItem('duoclips_lang', lang);
        };

        langSelect.addEventListener('change', (e) => {
            changeLanguage(e.target.value);
        });

        const savedLang = localStorage.getItem('duoclips_lang');
        if (savedLang) {
            langSelect.value = savedLang;
            changeLanguage(savedLang);
        }
    }

    // Wymuszenie odtwarzania wideo (Safari / iOS)
    const videos = document.querySelectorAll('video');
    videos.forEach(video => {
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.autoplay = true;
        video.play().catch(e => {
            console.log("Autoplay początkowo zablokowany:", e);
        });
    });

    const playVideos = () => {
        videos.forEach(video => {
            if (video.paused) {
                video.play().catch(() => {});
            }
        });
        document.removeEventListener('click', playVideos);
        document.removeEventListener('touchstart', playVideos);
        document.removeEventListener('scroll', playVideos);
    };
    
    document.addEventListener('click', playVideos);
    document.addEventListener('touchstart', playVideos);
    document.addEventListener('scroll', playVideos);
});